import { render, staticRenderFns } from "./SelectMatches.vue?vue&type=template&id=3f041a53&scoped=true"
import script from "./SelectMatches.vue?vue&type=script&lang=js"
export * from "./SelectMatches.vue?vue&type=script&lang=js"
import style0 from "./SelectMatches.vue?vue&type=style&index=0&id=3f041a53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f041a53",
  null
  
)

export default component.exports